"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistersPanelHeader = RegistersPanelHeader;
exports.RegistersPanelBody = RegistersPanelBody;
exports.Provider = exports.Consumer = exports.types = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Functions = require("../core/Functions");

var types = {
  registerPanelHeader: _propTypes.default.func,
  unregisterPanelHeader: _propTypes.default.func,
  registerPanelBody: _propTypes.default.func,
  unregisterPanelBody: _propTypes.default.func
};
exports.types = types;

var _React$createContext = _react.default.createContext({}),
    Consumer = _React$createContext.Consumer,
    Provider = _React$createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;

var Registration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Registration, _Component);

  function Registration() {
    (0, _classCallCheck2.default)(this, Registration);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Registration).apply(this, arguments));
  }

  (0, _createClass2.default)(Registration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Functions.callIfPossible)(this.props.register);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _Functions.callIfPossible)(this.props.unregister);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Registration;
}(_react.Component);

function RegistersPanelHeader() {
  return _react.default.createElement(Consumer, null, function (_ref) {
    var registerPanelHeader = _ref.registerPanelHeader,
        unregisterPanelHeader = _ref.unregisterPanelHeader;
    return _react.default.createElement(Registration, {
      register: registerPanelHeader,
      unregister: unregisterPanelHeader
    });
  });
}

function RegistersPanelBody() {
  return _react.default.createElement(Consumer, null, function (_ref2) {
    var registerPanelBody = _ref2.registerPanelBody,
        unregisterPanelBody = _ref2.unregisterPanelBody;
    return _react.default.createElement(Registration, {
      register: registerPanelBody,
      unregister: unregisterPanelBody
    });
  });
}